import React, { Component } from 'react';
import './Follow.css';

/**
 * Facebook SVG Icon
 */
export default class IconSvgFacebook extends Component {

    /**
     * Render
     *
     * @returns {XML}
     */
    render() {
        return (
        	<svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 50 50">
	        	<g transform="translate(1056, 672)">
		        	<path className="svg-icon-facebook" d="M-1031-671c-13.3,0-24,10.7-24,24s10.7,24,24,24s24-10.7,24-24S-1017.7-671-1031-671z M-1024.8-655h-2.2
		        	c-1.8,0-2.1,0.8-2.1,2.1v2.7h4.2l-0.5,4.3h-3.7v11h-4.4v-11h-3.7v-4.3h3.7v-3.2c0-3.7,2.2-5.6,5.5-5.6c1.6,0,2.9,0.2,3.3,0.2V-655z
		        	"/>
	        	</g>
        	</svg>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/global/follow/IconSvgFacebook.jsx